import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable({
  providedIn: 'root'
})
export class LinkDocumentService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {   }

  getLinkDocument(key) {

    var headers = new HttpHeaders({ 'Content-Type': 'application/json' })
      .set('Access-Control-Allow-Origin', '*');

    key = encodeURIComponent(key);
    var params = new HttpParams()
        .set( "key" , key);

    const url = `${apiConfig.uri}/linkDocuments/${key}`;

    return this.httpClient.get( url, { headers: headers, params : params });
  }

  updateLinkDocumentStatus(key, status) {

    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    // データベースに保存されている key は元々 URL Encodeされている。
    // 一方で送った Key は API Gatewayで一度 Decodeされてしまうので、二重にEncodeすることで Functionに届いたときに URL Encode された状態になるようにしている
    key = encodeURIComponent(key);
    key = encodeURIComponent(key);

    var headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    // var params = new HttpParams()
    //     .set( "key" , key);

    const postBody = {
      "status" : status,
    };


    const url = `${apiConfig.uri}/licence/${sectionId}/linkDocuments/${key}`;

    return this.httpClient.put( url, postBody, { headers: headers });
  }

}
